import Avatar from "@/components/blog/avatar";
import Date from "@/components/blog/date";
import Tags from "@/components/blog/tags";

export default function PostMeta({ post }) {
  return (
    <div className="lg:pl-12 mb-4 grid grid-cols-2 lg:grid-cols-1 gap-y-4 text-sm">
      <Avatar name={post.author.name} picture={post.author.picture} />
      <Date dateString={post.date} />
      <div className="col-span-full">
        <Tags tags={post.tags} />
      </div>
    </div>
  );
}
